import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["href"]




export default /*@__PURE__*/_defineComponent({
  __name: 'ImageContainer',
  props: {
    image: {
        type: String,
        required: true,
    },
    imageAlt: {
        type: String,
        required: true,
    },
    href: {
        type: String,
        required: false,
    },
    label: {
        type: String,
        required: false,
    },
    size: {
        type: Number,
        default: 400,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "ImageContainer",
    style: _normalizeStyle({ width: __props.size + 'px' })
  }, [
    _createElementVNode("img", {
      src: __props.image,
      alt: __props.imageAlt
    }, null, 8, _hoisted_1),
    (__props.href)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: __props.href,
          target: "_blank"
        }, _toDisplayString(__props.label), 9, _hoisted_2))
      : _createCommentVNode("", true)
  ], 4))
}
}

})